// extracted by mini-css-extract-plugin
export default {"info":"f+NBtKWG5-","h-rule":"dNIgqr8v07","hRule":"dNIgqr8v07","logo":"yf0v4QmgQx","further-resources":"_8M-bqQKgmA","furtherResources":"_8M-bqQKgmA"};